import './index.scss';
import React from 'react';
import emptyImgMap from './imageMap';
import '../../styles/listBlankV1.scss';
import { getCurrentSystem } from '@umu/ukit-lang';

import { If, PreImg } from 'common/src/components';
import { IProps } from './interface';

export default function (props: IProps) {
    const {
        type,
        blankImg = '',
        className = '',
        title = '',
        desc = '',
        button,
        children,
        buttonEvent,
        buttonText,
    } = props;

    const renderV1 = () => {
        return (
            <div className={`list-blank-v1-pc ${className}`}>
                <If condition={!!blankImg}>
                    <PreImg>
                        <img className="list-blank-img" src={blankImg} />
                    </PreImg>
                </If>
                <div className="list-blank-text">
                    <If condition={!!title}>
                        <div className="list-blank-title">{title}</div>
                    </If>
                    <If condition={!!desc}>
                        <div className="list-blank-desc">{desc}</div>
                    </If>
                    {children ? children : null}
                </div>
            </div>
        );
    };
    const renderV2 = () => {
        if (!type) {
            return renderV1();
        }
        const isOrientalArea = ['cn', 'tw', 'co'].includes(getCurrentSystem().toLocaleLowerCase());
        const url = isOrientalArea ? emptyImgMap[type].cn : emptyImgMap[type].com;

        return (
            <div className={`list-blank-pc ${className}`}>
                <img className="list-blank-img" src={url} />
                <div className="list-blank-text">
                    {title ? <p className="list-blank-title">{title}</p> : null}
                    {desc ? <div className="list-blank-desc"> {desc}</div> : null}
                </div>
                {buttonEvent ? (
                    <div className="list-blank-operation">
                        <div className="operation-button" onClick={buttonEvent}>
                            {buttonText}
                        </div>
                    </div>
                ) : null}
                {button ? <div className="list-blank-operation">{button}</div> : null}
            </div>
        );
    };

    return renderV2();
}
